export default (routeTo, routeFrom, next) => {
  /*
     if bookingId is not present redirect to property landing page
  */
  const { bookingId, permalink } = routeTo.params

  if (!bookingId) {
    next({ name: 'property-landing', params: { permalink } })
  } else {
    routeTo.params.layoutComponents = []

    next()
  }
}
